import "./App.css";

export default function EmailCard(props) {
  return (
    <div className="emailSingola">
      <h1>nome: {props.nome}</h1>
      <h3>email: {props.email}</h3>
      <h3>oggetto: {props.oggetto}</h3>
      <p>testo: {props.testo}</p>
    </div>
  );
}
